<template>
  <section class="review-awards eu" :class="{ desktop: $isDesktop }">
    <div class="hero eu">
      <div>
        <h1>
          <translate>Pitchup.com review awards</translate>
          <br v-if="$isDesktop" /><translate>Italy</translate> 2024
        </h1>
        <review-awards-pages-nav />
      </div>
    </div>

    <review-awards-intro />

    <section id="golds" class="top-5">
      <div class="golds-heading">
        <img
          loading="lazy"
          src="@/assets/images/pitchup-favicon.svg"
          alt=""
          width="36"
          height="32"
        />
        <translate tag="h2" :tt="{ numberOfSites: 20 }">
          Top {numberOfSites} campsites in Italy
        </translate>
      </div>
      <div class="top-5-data">
        <review-awards-top-sites :data="TopSitesITData" />
      </div>
    </section>
    <nuxt-to-meta :nuxt2meta="head" />
  </section>
</template>
<script setup lang="ts">
import SCHEMA_ORGANIZATION from '../../../../json/schemaOrganization.json'
import { computed } from 'vue'

definePageMeta({
  layout: 'default',
})

const TopSitesITData = [
  {
    id: '1',
    name: "Agricampeggio l'Essenza",
    region: 'Verona',
    url: '/campsites/italy/veneto/verona/brenzone/agricampeggio-lessenza/',
    rating: 9.9,
    reviewsCount: 49,
    pitchTypes: [
      {
        pitchTypesCount: 5,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 0,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 5,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '2',
    name: 'Camping Marmolada Malga Ciapela',
    region: 'Belluno',
    url: '/campsites/italy/veneto/belluno/rocca-pietore/camping-marmolada-malga-ciapela/',
    rating: 9.8,
    reviewsCount: 31,
    pitchTypes: [
      {
        pitchTypesCount: 46,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 35,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 35,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 5,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '3',
    name: 'Miramare Camping Village',
    region: 'Venezia',
    url: '/campsites/italy/veneto/venezia/cavallino-treporti/miramare_camping_village/',
    rating: 9.6,
    reviewsCount: 40,
    pitchTypes: [
      {
        pitchTypesCount: 35,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 35,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 35,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 20,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 10,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '4',
    name: 'Camping Sanfilippo',
    region: 'Palermo',
    url: '/campsites/italy/sicilia/palermo/cefalu/camping-sanfilippo/',
    rating: 9.5,
    reviewsCount: 22,
    pitchTypes: [
      {
        pitchTypesCount: 50,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 50,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 50,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 32,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '5',
    name: "Agricampeggio Ca' Romeo",
    region: 'La Spezia',
    url: '/campsites/italy/liguria/la-spezia/castelnuovo-magra/agricampeggio-ca-romeo/',
    rating: 9.5,
    reviewsCount: 20,
    pitchTypes: [
      {
        pitchTypesCount: 15,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 15,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '6',
    name: 'Agricamper Villa Julia Pompei',
    region: 'Napoli',
    url: '/campsites/italy/campania/napoli/pompei/agricamper-villa-julia-pompei/',
    rating: 9.4,
    reviewsCount: 131,
    pitchTypes: [
      {
        pitchTypesCount: 20,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 30,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 30,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '7',
    name: 'Campeggio Giglio',
    region: 'Brescia',
    url: '/campsites/italy/lombardia/brescia/gargnano/campeggio-giglio/',
    rating: 9.4,
    reviewsCount: 35,
    pitchTypes: [
      {
        pitchTypesCount: 17,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 17,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 17,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '8',
    name: 'Camping Sass Dlacia',
    region: 'Bolzano',
    url: '/campsites/italy/trentino-alto-adige/bolzano/san_cassiano/camping_sass_dlacia/',
    rating: 9.4,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 50,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 75,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 75,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 5,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '9',
    name: 'Agricamping Le Nosare',
    region: 'Verona',
    url: '/campsites/italy/veneto/verona/valeggio_sul_mincio/agricamping-le-nosare/',
    rating: 9.4,
    reviewsCount: 20,
    pitchTypes: [
      {
        pitchTypesCount: 4,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 5,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 5,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 10,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '10',
    name: 'Camping Delle Rose',
    region: 'Imperia',
    url: '/campsites/italy/liguria/imperia/isolabona/camping_delle_rose/',
    rating: 9.3,
    reviewsCount: 136,
    pitchTypes: [
      {
        pitchTypesCount: 100,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 100,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 100,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 12,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '11',
    name: 'Camping Village Miramare',
    region: 'Venezia',
    url: '/campsites/italy/veneto/venezia/chioggia/camping-village-miramare/',
    rating: 9.3,
    reviewsCount: 35,
    pitchTypes: [
      {
        pitchTypesCount: 365,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 365,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 365,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 55,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '12',
    name: 'Sivinos Camping Boutique',
    region: 'Brescia',
    url: '/campsites/italy/lombardia/brescia/manerba_del_garda/sivinos_camping_boutique/',
    rating: 9.3,
    reviewsCount: 30,
    pitchTypes: [
      {
        pitchTypesCount: 35,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 35,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 35,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 15,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '13',
    name: 'La Rosa nel Borgo',
    region: 'Cuneo',
    url: '/campsites/italy/piemonte/cuneo/la_morra/campeggio_cascina_ballarin/',
    rating: 9.3,
    reviewsCount: 22,
    pitchTypes: [
      {
        pitchTypesCount: 6,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 5,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 6,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '14',
    name: 'Camping Venezia Village',
    region: 'Venezia',
    url: '/campsites/italy/veneto/venezia/venezia/camping_venezia_village/',
    rating: 9.3,
    reviewsCount: 20,
    pitchTypes: [
      {
        pitchTypesCount: 40,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 40,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 40,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '15',
    name: 'Agricamping Lo Zafferano',
    region: 'Savona',
    url: '/campsites/italy/liguria/savona/albenga/agricamping-lo-zafferano/',
    rating: 9.2,
    reviewsCount: 27,
    pitchTypes: [
      {
        pitchTypesCount: 15,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 15,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 15,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '16',
    name: 'Camping Serenissima',
    region: 'Venezia',
    url: '/campsites/italy/veneto/venezia/mira/camping-serenissima/',
    rating: 9.0,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 100,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 100,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 100,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 30,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
      {
        pitchTypesCount: 5,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '17',
    name: 'Agriturismo Salos',
    region: 'Lecce',
    url: '/campsites/italy/puglia/lecce/otranto/agriturismo-salos/',
    rating: 8.9,
    reviewsCount: 35,
    pitchTypes: [
      {
        pitchTypesCount: 50,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 20,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 20,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 30,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '20',
    name: 'Camping Pian dei Boschi',
    region: 'Savona',
    url: '/campsites/italy/liguria/savona/pietra-ligure/camping_pian_dei_boschi/',
    rating: 8.9,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 10,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 10,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 10,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 3,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '18',
    name: 'Village Flaminio',
    region: 'Roma',
    url: '/campsites/italy/lazio/roma/roma/village-flaminio/',
    rating: 8.8,
    reviewsCount: 29,
    pitchTypes: [
      {
        pitchTypesCount: 150,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 150,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 150,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 50,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '19',
    name: 'Camping Village Mugello Verde',
    region: 'Firenze',
    url: '/campsites/italy/toscana/firenze/scarperia_e_san_piero/camping-village-mugello-verde/',
    rating: 8.8,
    reviewsCount: 24,
    pitchTypes: [
      {
        pitchTypesCount: 50,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 50,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 50,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 32,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 75,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
]

const { $t, $isDesktop } = useNuxtApp()

const title = computed(() => $t('Pitchup.com review awards') as string)

const description = computed(
  () =>
    $t(
      "Pitchup.com's review awards are based on nearly 200,000 customer reviews from 2024. Here's our shortlist of the top rated campsites.",
    ) as string,
)

const head = computed(() => {
  const images = import.meta.glob<{ default: string }>(
    '@/assets/images/review-awards-og-it.png',
    {
      query: '?url',
      eager: true,
    },
  )
  return {
    title: title.value,
    script: [schemaOrganization.value],
    meta: [
      {
        hid: 'og:title',
        property: 'og:title',
        content: title.value,
      },
      {
        hid: 'og:url',
        property: 'og:url',
        content: 'https://www.pitchup.com/review-awards/2024/italy/',
      },
      {
        hid: 'description',
        name: 'description',
        property: 'og:description',
        content: description.value,
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: images['/assets/images/review-awards-og-it.png'].default,
      },
      {
        hid: 'og:image:width',
        property: 'og:image:width',
        content: '1200',
      },
      {
        hid: 'og:image:height',
        property: 'og:image:height',
        content: '630',
      },
    ],
  }
})

const schemaOrganization = computed(() => ({
  type: 'application/ld+json',
  body: true,
  json: SCHEMA_ORGANIZATION,
  hid: 'schema-organization',
}))
</script>
<style>
@import url('~/assets/css/review-awards.css');
</style>
